import { render, staticRenderFns } from "./districtManage.vue?vue&type=template&id=9b59e9f8&scoped=true&"
import script from "./districtManage.vue?vue&type=script&lang=js&"
export * from "./districtManage.vue?vue&type=script&lang=js&"
import style0 from "./districtManage.vue?vue&type=style&index=0&id=9b59e9f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b59e9f8",
  null
  
)

export default component.exports